"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _createSuper2 = _interopRequireDefault(require("@babel/runtime/helpers/createSuper"));

var _react = _interopRequireDefault(require("react"));

var _styled = require("./styled");

var MessageActionLike = /*#__PURE__*/function (_React$PureComponent) {
  (0, _inherits2["default"])(MessageActionLike, _React$PureComponent);

  var _super = (0, _createSuper2["default"])(MessageActionLike);

  function MessageActionLike() {
    (0, _classCallCheck2["default"])(this, MessageActionLike);
    return _super.apply(this, arguments);
  }

  (0, _createClass2["default"])(MessageActionLike, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          id = _this$props.id,
          onClick = _this$props.onClick,
          liked = _this$props.liked,
          likeString = _this$props.likeString;
      return /*#__PURE__*/_react["default"].createElement(_styled.Button, {
        id: id,
        licorice: true,
        flat: true,
        onClick: onClick,
        size: "small"
      }, liked && /*#__PURE__*/_react["default"].createElement(_styled.LikedIcon, {
        color: "primary",
        fontSize: "inherit"
      }), !liked && /*#__PURE__*/_react["default"].createElement(_styled.LikeIcon, {
        fontSize: "inherit"
      }), likeString);
    }
  }]);
  return MessageActionLike;
}(_react["default"].PureComponent);

var _default = MessageActionLike;
exports["default"] = _default;